import { c as _c } from "react/compiler-runtime";
import type { ReactNode, ComponentProps } from 'react';
import { Tooltip } from 'react-tooltip';
export type WaveTooltipPlacement = ComponentProps<typeof Tooltip>['place'];
interface WaveTooltipProps {
  readonly id: string;
  readonly place: WaveTooltipPlacement;
  readonly children: ReactNode;
}
export const WaveTooltip = t0 => {
  const $ = _c(6);
  const {
    id,
    place,
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <span className="tw-text-xs">{children}</span>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== id || $[3] !== place || $[4] !== t1) {
    t2 = <Tooltip id={id} place={place} positionStrategy="fixed" className="tw-bg-[#37373E] tw-text-white tw-px-2.5 tw-py-1.5 tw-text-xs tw-font-medium tw-rounded-md tw-shadow-[0_4px_12px_rgba(0,0,0,0.3)] tw-z-[10000]">{t1}</Tooltip>;
    $[2] = id;
    $[3] = place;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};